<script>
import forminput from "../formcomponet/forminput.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import menus from "@/models/menus";
import appConfig from "@/app.config";

export default {
  mixins: [apibtoast, apigeneric, menus],
  props: ["Id", "AddEdit"],
  page: {
    title: "Menü Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      FormData: {},
      languages: {},
      MenuTranslationsData: [],
      linkfinddata: {},
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader,
    forminput,
    formcheckbox
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      if (this.AddEdit == "Add") {
        this.FormData.Websiteid = this.GettersWebsiteid;
      }
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("menus", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("menus");
            }
          });
        } else {
          this.Update("menus", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("menus");
            }
          });
        }
      }
    },
    Get() {
      this.ActionsGet({ 
        Service: "menus/linkbul/8820dd51-9e5c-4442-afdc-e98786bd3365/"+ window.$cookies.get("website"), 
        Page: this.Page
        }).then((res) => {
        this.linkfinddata = res.Data;
        
      });
      if (this.AddEdit == "Edit") {
        this.ActionsSingleGet({ Service: "menus", Id: this.Id }).then((res) => {
          this.FormData = res.Data;
        });
        let Page = {
          PageNumber: "1",
          PageSize: "99999",
          PageDataSize: "1",
        };
        this.ActionsGet({ Service: "languages", Page: Page }).then((res) => {
          this.languages = res.Data;
        });
      }
    },
    /*LanguagesGet(){
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };
      this.ActionsGet({ Service: "languages", Page: Page }).then((res) => {
        this.languages = res.Data;
          this.MenuTranslationsData=[];
        for (var i = 0; i < res.Data.length; i++) {
          var Data= {
                    Title: "",
                    Link: "",
                    Websiteid: this.GettersWebsiteid ,
                    Menuid: "",
                    Langid: res.Data[i].Id,
          } 

          if(this.AddEdit == "Edit"){ 
              this.ActionsFilterGet({ Service: "menutranslations", Page: Page,Filter: "&Langid="+res.Data[i].Id+"&Menuid="+this.FormData.Id }).then((result) => {
                if(result.Data.length > 0){  
                  this.MenuTranslationsData.push(result.Data[0]); 
                }else{   
                  this.MenuTranslationsData.push(Data);
                }
              });
                 
          }else{ 
                  // this.$set(this.MenuTranslationsData, res.Data[i].Id, Data)
                  this.MenuTranslationsData.push(Data);
          }
        }
      });
    },*/
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="menus"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('menus.AddEdit.FormTitleEdit')
          : $t('menus.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <b-tabs content-class="p-3 text-muted">
        <b-tab active class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <country-flag country="tr" size="small" />
            <span class="d-none d-sm-inline-block">Türkçe</span>
          </template>

          <Form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Title"
                  :Value="FormData.Title"
                  :v="$v.FormData.Title"
                  @input="FormData.Title = $event"
                />
              </div>
              <div class="col-md-6">
                <i
                  v-b-modal.linkfind
                  class="
                    position-absolute
                    top-0
                    end-0
                    mdi mdi-file-find-outline
                    me-1
                  "
                  >{{ $t("menus.AddEdit.Linkfind.Title") }}</i
                >
                <forminput
                  :FormDataType="FormDataType.Link"
                  :Value="FormData.Link"
                  :v="$v.FormData.Link"
                  @input="FormData.Link = $event"
                />
              </div>
                <formcheckbox
                  :FormDataType="FormDataType.Auth"
                  :Value="FormData.Auth"
                  :v="$v.FormData.Auth"
                  @input="FormData.Auth = $event"
                />
            </div>
            <div class="row" v-for="(Data, index) in languages" :key="index">
              <template>
                <div class="col-md-6 mb-3">
                  <b-form-group
                    :label="Data.Title + ' ' + FormDataType.Title.FieldTitle"
                    label-for="text"
                  >
                    <b-form-input
                      v-model="MenuTranslationsData[index].Title"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6 mb-3">
                  <b-form-group
                    :label="Data.Title + ' ' + FormDataType.Link.FieldTitle"
                    label-for="text"
                  >
                    <b-form-input
                      v-model="MenuTranslationsData[index].Link"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </template>
            </div>
            <button class="btn btn-primary" type="submit">
              {{ $t("menus.AddEdit.Button") }}
            </button>
          </Form>
        </b-tab>
        <template v-for="(Data, index) in languages">
          <b-tab :key="index" v-if="AddEdit == 'Edit'">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">
                <country-flag :country="Data.Flag" size="small" />{{
                  Data.Title
                }}</span
              >
            </template>
          </b-tab>
        </template>
      </b-tabs>
    </b-modal>
    <b-modal
      id="linkfind"
      size="standard"
      :title="$t('links.AddEdit.Linkfind.Title')"
      title-class="font-18"
      hide-footer
    >
      <div class="table-responsive">
        <table class="table mb-0">
          <tbody>
            <tr v-for="(Data, index) in linkfinddata" :key="index">
              <td>{{ Data.Type }} >> {{Data.Title}}</td>
              <td style="width: 100px; text-align: center">
                <b-button-group>
                  <b-button
                    variant="success"
                    @click="(FormData.Link = Data.Link), $bvModal.hide('linkfind')"
                    ><i class="fas fa-check"></i
                  ></b-button>
                </b-button-group>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </Loader>
</template>
